import { render, staticRenderFns } from "./DetailPurchaseOtherPayment.vue?vue&type=template&id=71b8cebe"
import script from "./DetailPurchaseOtherPayment.vue?vue&type=script&lang=js"
export * from "./DetailPurchaseOtherPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports